import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_ScrollText = _resolveComponent("ScrollText")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Artikel hinzufügen")
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.sWord,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sWord) = $event)),
            variant: "solo",
            label: "Suche",
            onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.doSearch(true)), ["enter"])),
            "append-inner-icon": "mdi-magnify",
            "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (_ctx.doSearch(true))),
            loading: _ctx.loading,
            autofocus: ""
          }, null, 8, ["modelValue", "loading"]),
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.ArtikelNr,
                  onClick: ($event: any) => (_ctx.selectItem(item))
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_v_list_item_action, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          (_ctx.selectedId === item.ArtikelNr)
                            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                key: 0,
                                indeterminate: ""
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item_subtitle, { class: "ml-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.ArtikelNr), 1)
                            ], undefined, true),
                            _: 2
                          }, 1024)
                        ])
                      ], undefined, true),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        (item.Bezeichnung1)
                          ? (_openBlock(), _createBlock(_component_ScrollText, {
                              key: 0,
                              text: item.Bezeichnung1
                            }, null, 8, ["text"]))
                          : _createCommentVNode("", true)
                      ], undefined, true),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        (item.Bezeichnung2)
                          ? (_openBlock(), _createBlock(_component_ScrollText, {
                              key: 0,
                              text: item.Bezeichnung2
                            }, null, 8, ["text"]))
                          : _createCommentVNode("", true)
                      ], undefined, true),
                      _: 2
                    }, 1024)
                  ], undefined, true),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}